var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCrosshair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 20.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 20.5,
    stroke: "#229596"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7143 22.2857H22.2857V28.7143C22.2857 29.0553 22.1503 29.3823 21.9091 29.6234C21.668 29.8645 21.341 30 21 30C20.659 30 20.332 29.8645 20.0909 29.6234C19.8497 29.3823 19.7143 29.0553 19.7143 28.7143V22.2857H13.2857C12.9447 22.2857 12.6177 22.1503 12.3766 21.9091C12.1355 21.668 12 21.341 12 21C12 20.659 12.1355 20.332 12.3766 20.0909C12.6177 19.8497 12.9447 19.7143 13.2857 19.7143H19.7143V13.2857C19.7143 12.9447 19.8497 12.6177 20.0909 12.3766C20.332 12.1355 20.659 12 21 12C21.341 12 21.668 12.1355 21.9091 12.3766C22.1503 12.6177 22.2857 12.9447 22.2857 13.2857V19.7143H28.7143C29.0553 19.7143 29.3823 19.8497 29.6234 20.0909C29.8645 20.332 30 20.659 30 21C30 21.341 29.8645 21.668 29.6234 21.9091C29.3823 22.1503 29.0553 22.2857 28.7143 22.2857Z",
    fill: "#229596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrosshair);
export default __webpack_public_path__ + "static/media/Icon_Crosshair.acffed21902defecc65ce2a24583d8f2.svg";
export { ForwardRef as ReactComponent };